import React from 'react';
import { Box, Button, Typography } from '@mui/material';

const CookieBanner = ({ theme, onAccept }) => (
  <Box
    role="dialog"
    aria-label="הסכמת עוגיות"
    sx={{
      position: 'fixed',
      left: 12,
      right: 12,
      bottom: 12,
      zIndex: 1400,
      maxWidth: 560,
      mx: 'auto',
      p: { xs: 2, sm: 2.5 },
      borderRadius: `${theme.radius}px`,
      bgcolor: theme.surface,
      border: `1px solid ${theme.border}`,
      boxShadow: theme.shadow,
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      gap: 2,
      alignItems: { sm: 'center' },
    }}
  >
    <Typography sx={{ flex: 1, color: theme.text, fontFamily: theme.fontBody, fontSize: '0.9rem', lineHeight: 1.45 }}>
      האתר שומר העדפות במחשב זה.
    </Typography>
    <Button
      onClick={onAccept}
      sx={{
        flexShrink: 0,
        px: 3,
        py: 1.1,
        minHeight: 44,
        borderRadius: 999,
        bgcolor: theme.accent,
        color: theme.accentContrast,
        fontWeight: 700,
        fontFamily: theme.fontBody,
        '&:hover': { bgcolor: theme.accentSoft },
      }}
    >
      מאשר
    </Button>
  </Box>
);

export default CookieBanner;
